var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1333 20.1334L21.5333 10.7334L19.6667 8.86675L12.1333 16.4001L8.33333 12.6001L6.46667 14.4667L12.1333 20.1334ZM14 27.3334C12.1556 27.3334 10.4222 26.9832 8.8 26.2827C7.17778 25.5832 5.76667 24.6334 4.56667 23.4334C3.36667 22.2334 2.41689 20.8223 1.71733 19.2001C1.01689 17.5779 0.666667 15.8445 0.666667 14.0001C0.666667 12.1556 1.01689 10.4223 1.71733 8.80008C2.41689 7.17786 3.36667 5.76675 4.56667 4.56675C5.76667 3.36675 7.17778 2.41653 8.8 1.71608C10.4222 1.01653 12.1556 0.666748 14 0.666748C15.8444 0.666748 17.5778 1.01653 19.2 1.71608C20.8222 2.41653 22.2333 3.36675 23.4333 4.56675C24.6333 5.76675 25.5831 7.17786 26.2827 8.80008C26.9831 10.4223 27.3333 12.1556 27.3333 14.0001C27.3333 15.8445 26.9831 17.5779 26.2827 19.2001C25.5831 20.8223 24.6333 22.2334 23.4333 23.4334C22.2333 24.6334 20.8222 25.5832 19.2 26.2827C17.5778 26.9832 15.8444 27.3334 14 27.3334Z",
    fill: "#15CA84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreenCheck);
export default __webpack_public_path__ + "static/media/circle_green_check.1e6dd61c2376aeb428f3c2d5a4fef848.svg";
export { ForwardRef as ReactComponent };